module.exports = __webpack_public_path__ + "img/doc_view_tile.f2c87f6e.png";